// Centered, single-active toast popup. Auto-dismisses through uiStore.

import { useUiStore } from "@/lib/store/uiStore";

export function Toast(): JSX.Element | null {
  const toast = useUiStore((s) => s.toast);
  if (!toast) return null;
  return (
    <div className="toast fade-up" role="status">
      <span style={{ color: "#4BC076" }}>✓</span>
      <span>{toast.msg}</span>
    </div>
  );
}
